
import React from "react";
import { LucideIcon } from "lucide-react";

interface MetricCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  iconColor: string;
  bgColor: string;
  isLoading?: boolean;
}

const MetricCard = ({ title, value, icon: Icon, iconColor, bgColor, isLoading }: MetricCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">
            {isLoading ? (
              <span className="animate-pulse bg-gray-200 rounded w-8 h-8 inline-block"></span>
            ) : (
              value.toLocaleString()
            )}
          </p>
        </div>
        <div className={`${bgColor} p-3 rounded-full`}>
          <Icon className={`h-6 w-6 ${iconColor}`} />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
